import {
  isQuotingToolAvailable,
  hasProcessPermission,
} from 'modules/common/permissions';

import { initProcessDetailsPage } from './detailsPage/data/sagas';
import ProcessDetailsPage from './detailsPage/entry';
import { initProcessListPage } from './listPage/data/sagas';
import ProcessList from './listPage/entry';

export default [
  {
    exact: true,
    path: '/processes',
    helpId: 'processes_list',
    component: ProcessList,
    saga: initProcessListPage,
    permissions: [isQuotingToolAvailable, hasProcessPermission],
  },
  {
    exact: true,
    path: '/processes/:processId',
    helpId: 'process_details',
    component: ProcessDetailsPage,
    saga: initProcessDetailsPage,
    permissions: [isQuotingToolAvailable, hasProcessPermission],
  },
];
